import React from 'react';

import { Icon, IconProps } from '@chakra-ui/react';

export const PersonIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 160 160"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <rect
      x="-0.000244141"
      y="3.05176e-05"
      width="160"
      height="160"
      fill="#F2F2F2"
    />
    <path
      d="M12.7998 141.075C12.7998 134.749 16.7689 129.103 22.7217 126.961L60.1237 113.504H98.9294L137.189 127C143.188 129.116 147.2 134.785 147.2 141.146V160.8H12.7998V141.075Z"
      fill="#E0E0E0"
    />
    <path
      d="M59.8401 94.5867H100.16V112.669C100.16 123.803 91.1341 132.829 80.0001 132.829C68.866 132.829 59.8401 123.803 59.8401 112.669V94.5867Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.593 31.5248C52.593 31.5248 75.1207 21.9668 103.174 31.0998C103.174 31.0998 100.199 20.0552 91.6978 18.3558C83.1969 16.657 53.0183 20.9046 52.593 31.5248Z"
      fill="#ACCBE1"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M108.941 103.368H103.9C95.4323 103.368 88.5681 96.5084 88.5681 88.0457V57.0128C88.5681 48.5501 95.4323 41.69 103.9 41.69H108.941C117.408 41.69 124.273 48.5501 124.273 57.0128V88.0457C124.273 96.5084 117.408 103.368 108.941 103.368Z"
      fill="#AEAEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M57.6128 104.392H55.8409C46.4704 104.392 38.8743 96.8002 38.8743 87.4359V68.0491C38.8743 58.6848 46.4704 51.0932 55.8409 51.0932H57.6128C66.9827 51.0932 74.5788 58.6848 74.5788 68.0491V87.4359C74.5788 96.8002 66.9827 104.392 57.6128 104.392Z"
      fill="#AEAEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M95.6281 56.6412C95.6281 74.4714 81.1652 88.9262 63.3237 88.9262C45.4829 88.9262 31.02 74.4714 31.02 56.6412C31.02 38.8111 45.4829 24.3563 63.3237 24.3563C81.1652 24.3563 95.6281 38.8111 95.6281 56.6412Z"
      fill="#AEAEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M128.683 50.0307C128.683 67.8608 114.221 82.3157 96.3791 82.3157C78.5383 82.3157 64.0754 67.8608 64.0754 50.0307C64.0754 32.2006 78.5383 17.7457 96.3791 17.7457C114.221 17.7457 128.683 32.2006 128.683 50.0307Z"
      fill="#AEAEAE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.9993 68.1867C37.9993 44.5413 57.1792 25.3727 80.8393 25.3727C104.499 25.3727 123.679 44.5413 123.679 68.1867C123.679 91.8328 104.499 111.001 80.8393 111.001C57.1792 111.001 37.9993 91.8328 37.9993 68.1867Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M123.68 80.7799C121.831 80.7799 120.32 79.4367 120.32 77.7948V56.9011C120.32 55.2592 121.831 53.916 123.68 53.916C125.528 53.916 127.04 55.2592 127.04 56.9011V77.7948C127.04 79.4367 125.528 80.7799 123.68 80.7799Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.9999 80.7799C36.1518 80.7799 34.6399 79.4367 34.6399 77.7948V56.9011C34.6399 55.2592 36.1518 53.916 37.9999 53.916C39.848 53.916 41.3599 55.2592 41.3599 56.9011V77.7948C41.3599 79.4367 39.848 80.7799 37.9999 80.7799Z"
      fill="#C4C4C4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M116.316 39.924C116.316 23.6187 100.07 10.4 80.0292 10.4C59.9882 10.4 43.7419 23.6187 43.7419 39.924C43.7419 39.924 72.502 44.2589 82.7256 44.2589C90.645 44.2589 116.316 39.924 116.316 39.924Z"
      fill="#AEAEAE"
    />
    <path
      d="M80.7563 79.7241L87.9621 77.5298C88.9061 77.2424 89.9045 77.7741 90.1921 78.7175C90.4797 79.6609 89.9476 80.6587 89.0037 80.9461L84.9035 83.3741C82.3366 84.8941 79.1372 84.8596 76.6036 83.2846L72.7805 80.9079C71.8413 80.6055 71.3252 79.5993 71.6278 78.6606C71.9305 77.722 72.9372 77.2062 73.8765 77.5087L80.7563 79.7241Z"
      fill="#AEAEAE"
    />
    <path
      d="M72.8486 94.3891C71.898 94.1242 71.3423 93.1394 71.6074 92.1894C71.8724 91.2395 72.8579 90.6841 73.8084 90.949C78.5359 92.2664 83.2454 92.2664 87.9728 90.949C88.9234 90.6841 89.9088 91.2395 90.1738 92.1894C90.4389 93.1394 89.8832 94.1242 88.9327 94.3891C83.5773 95.8816 78.2039 95.8816 72.8486 94.3891Z"
      fill="#AEAEAE"
    />
  </Icon>
);
